import { z } from "zod";
import { getFileBatchJsonSchema, getFileSchema } from "./get-file.schema";

export const deleteFileSchemaParam = getFileSchema;

export const deleteFileBatchJsonSchema = getFileBatchJsonSchema;
export const deleteFileSchemaJson = z.object({
	force: z.boolean(),
});
